import React from "react";
import { formatJobTaskReferenceValue } from "tap/utils/formatJobTaskReferenceValue.js";

/**
 * AG Grid cell renderer for job task reference fields (jobId, taskDetails, taskStatus).
 * API may return scalars or objects like { licensingJobId, catalogId } or
 * { licensingJobId, dealId }.
 * @param {Object} props
 * @param {unknown} props.value - Cell value from valueGetter or field
 * @param {Object} props.data - Row data
 * @param {Object} props.colDef - Column definition (includes field name)
 */
export function JobTaskReferenceCellRenderer({ value, data, colDef }) {
  const raw = value ?? data?.[colDef?.field];
  let display = formatJobTaskReferenceValue(raw);

  if (display && typeof display === "object") {
    display = formatJobTaskReferenceValue(display);
  }

  if (!display) {
    return null;
  }

  return <span>{String(display)}</span>;
}
